(function () {
  var grid = document.getElementById('searchspring-content');
  if (!grid) return;
  var addSaleFrom = function () {
    var search = window.searchspring && searchspring.controller && searchspring.controller.search;
    if (!search) return;
    grid.querySelectorAll('.ss__result').forEach(function (tile) {
      var row = tile.querySelector('.ss__result__name');
      var id = tile.id.split('-').pop();
      if (!row || row.dataset.saleFrom === id) return;
      var result = search.store.results.find(function (r) { return r.id == id; });
      if (!result) return;
      row.dataset.saleFrom = id;
      tile.querySelectorAll('.product-sale-from').forEach(function (line) { line.remove(); });
      var variants;
      try {
        variants = JSON.parse(result.attributes.variants).map(function (v) {
          return { available: v.available_for_sale, price: Math.round(v.price * 100), compare_at_price: Math.round(v.compare_at_price * 100) };
        });
      } catch (e) {
        return;
      }
      var label = theme.utils.saleFrom(variants);
      if (!label) return;
      var line = document.createElement('p');
      line.className = 'product-sale-from';
      line.textContent = label;
      row.after(line);
    });
  };
  addSaleFrom();
  new MutationObserver(addSaleFrom).observe(grid, { childList: true, subtree: true });
})();

var store_url2 = $('body').data('store');
var cookie_domain2 = ".cosabella.com";
var path2 = "/";
var cookie_duration_in_days2 = 30;
document.addEventListener("DOMContentLoaded", function() {

  const urlParams = new URLSearchParams(window.location.search);
  const sanitise = urlParams.get('sanitise');
  if(sanitise){
        let sanitiseImages = document.getElementsByClassName("sanitise_slide");
        for (var i = 0; i < sanitiseImages.length; i++) {
          sanitiseImages[i].style.display = 'none';
          
        }
  
    setTimeout(function() { 
        let sanitiseElements = document.getElementsByClassName("product-tile__image--hover");
        for (var i = 0; i < sanitiseElements.length; i++) {
          if(sanitiseElements[i].innerHTML.includes('_ZM_BK')){
            sanitiseElements[i].parentElement.classList.remove("has-hover-image");
            sanitiseElements[i].removeChild(sanitiseElements[i].firstElementChild);
          }
          
        }

     }, 2000);

   document.getElementById("sanitizeFooterBar").style.display = 'Block';
    document.getElementById("pixlee_container").remove();

  }
});
function removeURLParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts= url.split('?');   
    if (urlparts.length>=2) {

        var prefix= encodeURIComponent(parameter)+'=';
        var pars= urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i= pars.length; i-- > 0;) {    
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {  
                pars.splice(i, 1);
            }
        }

        url= urlparts[0]+'?'+pars.join('&');
        return url;
    } else {
        return url;
    }
}

function renderChartByRange(){
  var szRange = $("#szRange").val();
  var szSize = $("#szSize").val();
  var exponeaResult = exponea.showWebLayer('64c3e71679911c765dac3e6e', {range: szRange, size: szSize, style: 'NEVER1301',close:'true'});
}

function renderChartBySize(){
  var szRange = $("#szRange").val();
  var szSize = $("#szSize").val();
  var exponeaResult = exponea.showWebLayer('64c3e71679911c765dac3e6e', {range: szRange, size: szSize, style: 'NEVER1301',close:'true'});
}

function onElementInserted(containerSelector, elementSelector, callback) {

    var onMutationsObserved = function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length) {
                var elements = $(mutation.addedNodes).find(elementSelector);
                for (var i = 0, len = elements.length; i < len; i++) {
                    callback(elements[i]);
                }
            }
        });
    };

    var target = $(containerSelector)[0];
    var config = { childList: true, subtree: true };
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    var observer = new MutationObserver(onMutationsObserved);    
    observer.observe(target, config);

}

function renderChartByRange(){
  var szRange = $("#szRange").val();
  var szSize = $("#szSize").val();
  var exponeaResult = exponea.showWebLayer('64c3e71679911c765dac3e6e', {range: szRange, size: szSize, style: 'NEVER1301',close:'true'});
}

function renderChartBySize(){
  var szRange = $("#szRange").val();
  var szSize = $("#szSize").val();
  var exponeaResult = exponea.showWebLayer('64c3e71679911c765dac3e6e', {range: szRange, size: szSize, style: 'NEVER1301',close:'true'});
}

function removeActiveSaleBlock(){
   $(".saleColBox").each(function(){
     if($(this).hasClass("activeCol")){
       $(this).removeClass("activeCol");
     }
  });
} 


function scrollFilters(){
  var target = $(".filter__options--wrapper");
  if(target.hasClass("ss-show-overflow")) {
      $('.ss-show-overflow').animate({
      scrollTop: - $('.ss-show-overflow').offset().top + $(".ss-show-overflow > div:nth-child(2)").offset().top
      }, 1500);
      $('.ss-show-overflow').trigger('touchstart');
      $('.ss-show-overflow').on('touchstart', function() { 
        $('.ss-show-overflow').stop().animate({top: '10px'}, 600, 'easeOutBounce'); 
      }); 
  }
}

$(document).ready(function(){
   /*if (window.history && window.history.pushState){*/
     var checkoutTxt = $("#checkout_text").val();
      $(".cart-flyout-container .js-checkout-link").html(checkoutTxt);
   // }
  $(".line-item--gift-box .line-item__image").click(function(e){
    e.preventDefault();
    return false;
  });
  $(".line-item--gift-box .line-item__title").click(function(e){
    e.preventDefault();
    return false;
  });
   $(".saleColBox").click(function(){
    removeActiveSaleBlock();
    $(this).addClass("activeCol");
    $('html, body').animate({
        scrollTop: ($("#saleEndDiv").offset().top)-200
    }, 1100);
  });
  
  /*$(".template-cart #cart-note").bind('change propertychange', function() {
    $(".template-cart .cart__note").find("button").trigger("click");
  });*/
  var textMsg1 = $(".text-message1");
  var textMsg2 = $(".text-message2");
  if(textMsg1.length > 0 && textMsg2.length > 0){
    $(".text-message1").show();
    $(".text-message2").hide();
    var transition_time = $("#transition_time").val();
    setInterval(function() { $(".text-message1").toggle();$(".text-message2").toggle(); }, transition_time);
  }
  if(textMsg1.length > 0 && textMsg2.length <= 0){
    $(".text-message1").show();
   }
  if(textMsg1.length <= 0 && textMsg2.length > 0){
    $(".text-message2").show();
   }

if (navigator.userAgent.match(/(iPad|iPhone|iPod)/i)){
  $("html").addClass("iphone-body");
} 
  if (navigator.userAgent.match(/Android/)) {
  $("html").addClass("android-body");
} 
   $("#searchBarIcon").click(function(){
     $("#flyout-DSearch").addClass("flyout-active-top");
    //$("#search-input").focus();
     setTimeout(function() { $('input[name="q"]'). focus() }, 100);
    $("#flyout-DSearch").show();
  });
  $("#search-CloseBtn").click(function(){
    $("#flyout-DSearch").removeClass("flyout-active-top");
    $("#flyout-DSearch").hide();
  });
   $("#SearchFormBtn").click(function(){
    var searchQuery = $("#search-input").val();
    $(".search-form").submit();
  });
  if(window.matchMedia("(max-width: 995px)").matches){
  }else{
  $(".menu__subcategories").click(function(e){
    e.preventDefault();
    var pid = $(this).attr("id");
    if(pid == "shopBySize"){
       var menuHref = $(this).find("a").attr("href");
    window.location.href = menuHref;
    }else{
      var menuCat = $.trim($(this).text());
    var lastClick = $.cookie("last_click");
    $.cookie("last_click", menuCat, {
      domain: cookie_domain2,
      path : path2
    });
    var menuHref = $(this).attr("href");
    window.location.href = menuHref;
    }
    
  });

  $(".menu__color-link").click(function(e){
    e.preventDefault();
    var menuCat = $.trim($(this).text());
    var lastClick = $.cookie("last_click");
    $.cookie("last_click", null, {
      domain: cookie_domain2,
      path : path2
    });
    var menuHref = $(this).attr("href");
    window.location.href = menuHref;
  });

   
  $(".menu__categories").click(function(e){
    e.preventDefault();
    var menuCat = $.trim($(this).text());
    var lastClick = $.cookie("last_click");
    $.cookie("last_click", null, {
      domain: cookie_domain2,
      path : path2
    });
    var menuHref = $(this).attr("href");
    window.location.href = menuHref;
  });
  }
  var range = "";
  if (Cookies.get('selected_bra_type')){
    $(".find_fit_div").show();
    var cookie_range = Cookies.get('selected_bra_type');
    range = decodeURIComponent(cookie_range);
  }else{
     $(".find_fit_div").hide();
  }
  $("#find_fit").click(function(){
    var productId = theme.product.id;
    var productTags = theme.product.tags;
    var style = "";
    var stag = "";
    $.each(productTags, function( index, value ) {
      var tag = value;
      if(tag.indexOf("YGroup_") > -1){
        stag = tag.split("YGroup_");
      }
    });
    style = stag[1];
    if(range.indexOf(",") > -1){
      lastindexC = range.lastIndexOf(",");
      range = range.substring(lastindexC+1);
    }
    var selectedSize = Cookies.get('selected_size');
    if(style && productId && range && selectedSize){
      var product_range = range.toUpperCase();
      exponea.showWebLayer('64c3e71679911c765dac3e6e',{range: product_range, size: selectedSize, style: style,close:'false',productId: productId});
      console.log(stag[1]+"==="+productId+"==="+product_range+"==="+selectedSize);
    
    }
  
  });
  jQuery(".complete-look-link").click(function(e){
    e.preventDefault();
    var scrollTop1 = (jQuery("#js-product-complete").offset().top) - 180;
    jQuery('html,body').animate({
      scrollTop: scrollTop1
    }, 1000);
  });
  $("#cart-note").bind('blur', function() {
 // $("#submit_notes").trigger("click");
});
  $(".quantity-selector").each(function(){
    var objParent = $(this);
    var pid = $(this).find("input").data("productid");
    var cartItems = theme.cart.content.items;
     for(var i = 0;i < cartItems.length; i++){
      var itm = theme.cart.content.items;
      var obj = itm[i];
     if(obj){
       var oid = obj.id;
       var qty = obj.quantity;
       if(oid == pid){
         objParent.find("input").val(qty);
       }
         
      }
      
    }
  });
  $("#no-menu-btn").click(function(e){
    e.preventDefault();
    var linkURL = $(this).find("a").attr("href");
    window.location.href = linkURL;
  });
});

$('.js-form-colors').on('change', function(){
  let json = window.location.href+'.json';
  $.getJSON(json, function( data ) {

    // Fixes ReCharge widget not updating on colour change
    $('.form--product__add-to-cart .rc-container-wrapper').remove();
    //ReChargeWidget.createWidget({ productId: data.product.id, injectionParent: '.form--product__add-to-cart' });
  });

});
function PercentageDiscountRounded(percent,lineItemPrice) {
  
  let discount = (100 - percent) / 100.0;
  let new_price = Math.floor(lineItemPrice * 0.01 * discount * 4) / 4;
  
  return new_price;
  
}
function createBreadcrumb(){
  var pageURL = $("#collection-handle").val();
  var lastClick = decodeURIComponent($.cookie("last_click"));   
  if(pageURL.indexOf("/collections/") > -1 && lastClick && lastClick != "null" && lastClick != 'undefined'){
       var ele1 = '';
       var ele2 = '';
       $(".breadcrumb_list").html("");
        $(".header__navigation ul.parent-Items").find("a").each(function(){
          var currentExist = $(".breadcrumb_list").find(".current");
          if(currentExist && $(".breadcrumb_list").find("li").length > 0){
            
          }else{
            var liHref = $(this).attr("href");
            var liTxt = $.trim($(this).clone().children().remove().end().text());
              if(liHref){
                var myArray = pageURL.split("/collections/");
                var collectionHandle = "/collections/"+myArray[1];
                  if(liHref == collectionHandle && lastClick == liTxt ){
                  var classList = $(this).attr('class');
                  if(classList == "menu__subcategories"){
                    var imParent = $(this).parents().eq(5);
                    $(".breadcrumb_list").append("<li class='breadcrumb_link'><a href='/'>Home</a><span class='sep'>></span></li>");
                    if(!imParent.hasClass("parent-Items")){
                      var imParent = $(this).parents().eq(5).find("a");
                      if(imParent.hasClass("menu__categories")){
                        var imParentTxt = $(this).parents().eq(5).find("a.menu__categories").clone().children().remove().end().text();
                        var imParentLk = $(this).parents().eq(5).find("a.menu__categories").clone().children().remove().end().attr("href");
                        if(imParentTxt && imParentLk != "#"){
                          $(".breadcrumb_list").append("<li class='breadcrumb_link'><a href='"+imParentLk+"'>"+imParentTxt+"</a><span class='sep'>></span></li> ");
                          ele1 = imParentTxt;
                        }
                      }
                      
                    }else{
                       var imParent = $(this).parents().eq(4).find("a");
                      if(imParent.hasClass("menu__categories")){
                        var imParentTxt = $(this).parents().eq(4).find("a.menu__categories").clone().children().remove().end().text();
                        var imParentLk = $(this).parents().eq(4).find("a.menu__categories").clone().children().remove().end().attr("href");
                        if(imParentTxt && imParentLk != "#"){
                          $(".breadcrumb_list").append("<li class='breadcrumb_link'><a href='"+imParentLk+"'>"+imParentTxt+"</a><span class='sep'>></span></li> ");
                          ele1 = imParentTxt;
                        }
                      }
                    }
                    var imParent1 = $(this).parents().eq(1).find("a");
                    if(imParent1){
                      if(imParent1.hasClass("menu__cb-parent-link")){
                        var imParentTxt = $(this).parents().eq(1).find(".menu__cb-parent-link").clone().children().remove().end().text();
                        var imParentLk = $(this).parents().eq(1).find(".menu__cb-parent-link").attr("href");
                        if(imParentTxt && imParentLk != "#"){
                          //$(".breadcrumb_list").append("<li class='breadcrumb_link'><a href='"+imParentLk+"'>"+imParentTxt+"</a><span class='sep'>></span></li>");
                          //ele2 = imParentTxt;
                        }
                      }
                    }
                    $(".breadcrumb_list").append("<li class='breadcrumb_link'><span class='current'>"+liTxt+"</span></li>");
                    generateGoogleSchema("Home",ele1,ele2,liTxt);
                  }
                  if($(this).hasClass("menu__categories")){
                    $(".breadcrumb_list").append("<li class='breadcrumb_link'><a href='/'>Home</a><span class='sep'>></span></li>");
                    var liTxt = $(this).find(".menu__color-title").clone().children().remove().end().text();
                    $(".breadcrumb_list").append("<li class='breadcrumb_link'><span class='current'>"+liTxt+"</span></li>");
                    generateGoogleSchema("Home",ele1,ele2,liTxt);
                  }
                }
                
              }
            }
        });         
     
  }
  else{
    var ele1 = '';
    var ele2 = '';
    if(pageURL.indexOf("/collections/") > -1){
      $(".breadcrumb_list").html("");
      $(".header__navigation ul.parent-Items").find("a").each(function(){
        var currentExist = $(".breadcrumb_list").find(".current");
        if(currentExist && $(".breadcrumb_list").find("li").length > 0){}
        else{
          var liHref = $(this).attr("href");
          var liTxt = $.trim($(this).text());
            if(liHref){
             
              var myArray = pageURL.split("/collections/");
              var collectionHandle = "/collections/"+myArray[1];
                 if(liHref == collectionHandle){
                  
                  var classList = $(this).attr('class');
                if(classList == "menu__subcategories"){
                  var imParent = $(this).parents().eq(5);
                  $(".breadcrumb_list").append("<li class='breadcrumb_link'><a href='/'>Home</a><span class='sep'>></span></li>");
                  if(!imParent.hasClass("parent-Items")){
                    var imParent = $(this).parents().eq(5).find("a");
                    if(imParent.hasClass("menu__categories")){
                      var imParentTxt = $(this).parents().eq(5).find("a.menu__categories").clone().children().remove().end().text();
                      var imParentLk = $(this).parents().eq(5).find("a.menu__categories").clone().children().remove().end().attr("href");
                      if(imParentTxt && imParentLk != "#"){
                        $(".breadcrumb_list").append("<li class='breadcrumb_link'><a href='"+imParentLk+"'>"+imParentTxt+"</a><span class='sep'>></span></li> ");
                        ele1 = imParentTxt;
                      }
                    }
                  }else{
                     var imParent = $(this).parents().eq(4).find("a");
                    if(imParent.hasClass("menu__categories")){
                      var imParentTxt = $(this).parents().eq(4).find("a.menu__categories").clone().children().remove().end().text();
                      var imParentLk = $(this).parents().eq(4).find("a.menu__categories").clone().children().remove().end().attr("href");
                      if(imParentTxt && imParentLk != "#"){
                        $(".breadcrumb_list").append("<li class='breadcrumb_link'><a href='"+imParentLk+"'>"+imParentTxt+"</a><span class='sep'>></span></li> ");
                        ele1 = imParentTxt;
                      }
                    }
                  }
                  var imParent1 = $(this).parents().eq(1).find("a");
                  if(imParent1){
                    if(imParent1.hasClass("menu__cb-parent-link")){
                      var imParentTxt = $(this).parents().eq(1).find(".menu__cb-parent-link").text();
                      var imParentLk = $(this).parents().eq(1).find(".menu__cb-parent-link").attr("href");
                      if(imParentTxt && imParentLk != "#"){
                       // $(".breadcrumb_list").append("<li class='breadcrumb_link'><a href='"+imParentLk+"'>"+imParentTxt+"</a><span class='sep'>></span></li>");
                        //ele2 = imParentTxt;
                      }
                    }
                  }
                  $(".breadcrumb_list").append("<li class='breadcrumb_link'><span class='current'>"+liTxt+"</span></li>");
                  generateGoogleSchema("Home",ele1,ele2,liTxt);
                }
                else{
                  if($(this).hasClass("menu__color-link")){
                    $(".breadcrumb_list").append("<li class='breadcrumb_link'><a href='/'>Home</a><span class='sep'>></span></li>");
                    var liTxt = $(this).find(".menu__color-title").text();
                    $(".breadcrumb_list").append("<li class='breadcrumb_link'><span class='current'>"+liTxt+"</span></li>");
                    generateGoogleSchema("Home",'','',liTxt);
                  }
                  if($(this).hasClass("menu__categories")){
                    $(".breadcrumb_list").append("<li class='breadcrumb_link'><a href='/'>Home</a><span class='sep'>></span></li>");
                    var liTxt = $(this).clone().children().remove().end().text();
                    $(".breadcrumb_list").append("<li class='breadcrumb_link'><span class='current'>"+liTxt+"</span></li>");
                    generateGoogleSchema("Home",'','',liTxt);
                  }
                }
              }
            }
      }
      
      });
      
    }
    
  }
}

function generateGoogleSchema(ele1,ele2,ele3,ele4){
     var elem1 = $.trim(ele1);
     var elem2 = $.trim(ele2);
     var elem3 = $.trim(ele3);
     var elem4 = $.trim(ele4);
     var elems = [];
     var eleCount = 1;
  var storeURL = $("#storeURL").val();
        var elems1 =  {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": storeURL
      };
        elems.push(elems1); 
      if(elem2.length > 0){
      var eleURL = getURLFromText(ele2);
        if(eleURL.indexOf("#") < 0){
          var elems2 = {
          "@type": "ListItem",
          "position": ++eleCount,
          "name": $.trim(ele2),
          "item": eleURL
          };
          elems.push(elems2);
        }
     }
    if(elem3.length > 0){
      var eleURL = getURLFromText(ele3);
       if(eleURL.indexOf("#") < 0){
       var elems3 = {
        "@type": "ListItem",
        "position": ++eleCount,
        "name": $.trim(ele3),
        "item":  eleURL
      };
      elems.push(elems3);
       }
     }
  if(elem4.length > 0){
     var eleURL = getURLFromText(ele4);
        if(eleURL.indexOf("#") < 0){
          var elems4 = {
          "@type": "ListItem",
          "position": ++eleCount,
          "name": $.trim(ele4),
          "item": eleURL
          };
          elems.push(elems4);
        }
     }
     var storeURL = $("#storeURL").val();
      var el = document.createElement('script');
       el.type = 'application/ld+json';
       el.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": 
       elems
    });

    document.querySelector('head').appendChild(el);
}

function getURLFromText(ele){
  var elem = $.trim(ele).toLowerCase();
  var storeURL = $("#storeURL").val();
  var URLAddr = '';
   $(".header__navigation ul.parent-Items").find("a").each(function(){
      var liTxt = $.trim($(this).clone().children().remove().end().text()).toLowerCase();
      if(liTxt == elem){
        var liHref = storeURL+($(this).attr("href"));
        URLAddr = liHref;
      }
   });
  return URLAddr;
}

function relatedProduct(t){
    $.get("?section_id=product__recommendations", function (t) {
     $(".js-product-recommendations").html(t);
      var swiperMainCollection = new Swiper("#product-recommendation", {
        direction: 'horizontal',
        centeredSlides: false,
        slidesPerView:'auto',
        spaceBetween: 14,
        grabCursor:true,
        noSwipingSelector:'button',
        loop:false,
        speed: 400,
        observer: true,
        cssWidthAndHeight: true,
        visibilityFullFit: true,
        autoResize: false,
        freeMode: true,
        resistanceRatio: 0,
        shortSwipes: true,
        longSwipes:false,
        slidesPerGroup:2,
        mousewheel: {
          forceToAxis: true
        },
        navigation: {
          nextEl: ".thumb-next-rec",
          prevEl: ".thumb-prev-rec",
        },
        touchAngle:180
    });
    });
  }

function sendLinkToCustomer(){        
        var customerFormData = new FormData();
        customerFormData.append('email', $('#account-email').val());
        var AjaxUrl = "https://cosabella.thegenielab.com/send-activation-link-to-customer?shop=cosabella-north-america.myshopify.com"
            $.ajax({
              type: 'POST',
              url: AjaxUrl,
              processData: false,
              contentType: false,
              data: customerFormData,      
              success: function(proResultData) { 
                if(proResultData.status==true){
                   $('#account-email').val('');  
                   $('.success-activation').show();
                   $('.errors-activation').hide();
                   $('.success-activation').html(proResultData.message);
                }else{
                  $('#account-email').val('');  
                  $('.success-activation').hide();
                  $('.errors-activation').show();
                  $('.errors-activation').html(proResultData.message);
                  setTimeout(function(){ $('.errors-activation').hide(); }, 6000);

                }      
              },
              error: function (err) {
              console.log(err);              
              }
            });       
           
}

(function () {
  var grid = document.getElementById('searchspring-content');
  if (!grid) return;
  new MutationObserver(function () {
    var search = window.searchspring && searchspring.controller && searchspring.controller.search;
    if (!search) return;
    var added = false;
    grid.querySelectorAll('.ss__result').forEach(function (tile) {
      var name = tile.querySelector('.ss__result__name');
      var id = tile.id.split('-').pop();
      var badge = tile.querySelector('.stamped-product-reviews-badge');
      if (!name || (badge && badge.dataset.id === id)) return;
      var result = search.store.results.find(function (r) { return r.id == id; });
      if (!result) return;
      if (badge) badge.remove();
      badge = document.createElement('span');
      badge.className = 'stamped-product-reviews-badge';
      badge.dataset.id = id;
      badge.dataset.productSku = result.attributes.mfield_information_style || String(result.attributes.ss_personalization_childskus || '').split('-')[0];
      name.after(badge);
      added = true;
    });
    if (added && window.StampedFn && window.jQueryStamped) StampedFn.loadBadges();
  }).observe(grid, { childList: true, subtree: true });
})();
